<div class="modal-header">
  <h2 class="modal-title mb-0">Génération livrable</h2>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body p-4">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="row mb-3 align-items-center">
      <div class="col-md-3">
        <label for="nomClient" class="form-label mb-0">Client</label>
      </div>
      <div class="col-md-9">
        <input
          type="text"
          class="form-control"
          id="nomClient"
          formControlName="nomClient"
          placeholder="Ex : Marquere Cie"
        />
      </div>
    </div>

    <div class="row mb-3 align-items-center">
      <div class="col-md-3">
        <label for="nomProjet" class="form-label mb-0">Nom du projet</label>
      </div>
      <div class="col-md-9">
        <input
          type="text"
          class="form-control"
          id="nomProjet"
          formControlName="nomProjet"
          placeholder="Ex : 345 - Marquere à Chaponost"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="form-check mb-2">
          <input type="checkbox" id="csvProjet" formControlName="csvProjet" class="form-check-input me-2" />
          <label for="csvProjet" class="form-check-label">CSV Projet</label>
        </div>
        <div class="form-check">
          <input type="checkbox" id="csvSlide" formControlName="csvSlide" class="form-check-input me-2" />
          <label for="csvSlide" class="form-check-label">CSV Présentation</label>
        </div>
        <div class="form-check">
          <input type="checkbox" id="csvDevis" formControlName="csvDevis" class="form-check-input me-2" />
          <label for="csvDevis" class="form-check-label">CSV Devis</label>
        </div>
        <div class="form-check">
          <input type="checkbox" id="csvVE" formControlName="csvVE" class="form-check-input me-2" />
          <label for="csvVE" class="form-check-label">CSV Validation engagement</label>
        </div>
      </div>

      <div #screenshotContainer class="col-md-6 d-flex justify-content-center align-items-center" *ngIf="isParentForm">
        <i class="bi bi-camera-fill text-secondary" style="font-size: 6rem; color: black; cursor: pointer;"
            (click)="takeScreenshot()"
        >
        </i>
      </div>
    </div>

    <div class="row mb-3 align-items-center">
      <div class="col-md-1">
        <button type="button" class="btn btn-primary" (click)="openSharepointPicker()">
          <i class="bi bi-folder"></i>
        </button>
      </div>
      <div class="col-md-9">
        <input
          type="text"
          class="form-control"
          placeholder="URL"
          readonly
          style="background-color: #eee;"
          formControlName="urlFolder"
        />
      </div>
      <div *ngIf="submitted && formGroup.get('urlFolder')?.invalid" class="text-danger">
        La sélection d'un dossier est obligatoire
      </div>
    </div>

    <div class="text-end mt-4">
      <button type="submit" class="btn btn-primary">Générer</button>
    </div>
  </form>
</div>